module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "vulcan--dataset-cover.1d6bfa66.jpg";